import { BsGear } from 'react-icons/bs';

import BayTooltip from '../../BayTooltip';
import { StyledNavButton } from '../styles/navStyles';

interface SettingsButtonProps {
	toggleFunc: () => void;
	isActive?: boolean;
}

const SettingsButton = ({ toggleFunc, isActive = false }: SettingsButtonProps) => {
	return (
		<BayTooltip overlay={<span>Settings</span>} placement="bottom">
			<StyledNavButton
				className="desktop-menu-icons me-0"
				$isActive={isActive}
				onClick={() => toggleFunc()}
			>
				<BsGear size={16} />
			</StyledNavButton>
		</BayTooltip>
	);
};

export default SettingsButton;
